import * as Sentry from '@sentry/react';

let lastShownEventId = null;

function maybeShowDialog() {
    const eventId = Sentry.lastEventId();
    if (eventId && lastShownEventId !== eventId) {
        lastShownEventId = eventId;
        setTimeout(() => {
            Sentry.showReportDialog({ eventId });
        }, 1000);
    }
}

export function setupSentryGlobalHandlers() {
    window.addEventListener("error", (event) => {
        Sentry.captureException(event.error || event.message);
        console.log("[Sentry] Global error captured");
        maybeShowDialog();
    });

    window.addEventListener("unhandledrejection", (event) => {
        Sentry.captureException(event.reason);
        console.log("[Sentry] Unhandled rejection captured");
        maybeShowDialog();
    });
}
